// import React from "react";
// import './newMenuCard.scss';
// import SelectItems from "./SelectItem";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { diet, foodTasteLabels } from "../../Utills/enums";
// import Note from "./note";

// const MenuCard = ({ src, menuId, title, typeIcons = [], dietIcon, description, price, tab,unit, currency = '₹', isAvailable, showNote, note }) => {
//     const { restaurant, id, table } = useParams();
//     const cart = useSelector((state) => state?.user.cart);
//     const guestUser = useSelector((state) => state?.user.guestUser);
//     const navigate = useNavigate();
//     console.log("unit",unit)
//     const openDetailPage = () => {
//         navigate(`/${restaurant}/${id}/${table}/menu/item/${menuId}`);
//     };

//     return (
//         <li className={isAvailable ? 'menu-li-wrapper' : 'menu-li-wrapper over'}>
//             <div className="menuCard">

//                 {/* 1. LEFT COLUMN: Content & Details */}
//                 <div onClick={openDetailPage} className="menuText">
//                     <div className="menu-tags-row">
//                         {dietIcon && (
//                             <div className="dietIcon">
//                                 <img src={dietIcon} alt="diet preference" className="dietIconImg" />
//                             </div>
//                         )}

//                        {unit?.foodTasteMapping?.map((taste) => (
//                             <label key={taste.foodTasteMappingId}
//                                 className={
//                                 taste.foodTasteId === 8
//                                     ? "jain-badge-card"
//                                     : "spicy-badge-card"
//                                 }
//                             >
//                                 {foodTasteLabels[taste.foodTasteId]}
//                             </label>
//                         ))}

//                         {/* <label className="spicy-badge-card">🌶️ Spicy</label>
//                         <label className="spicy-badge-card">🌿 Jain</label>
//                         <label className="spicy-badge-card">⭐ Bestseller</label> */}
//                     </div>

//                     <h3 className="menuTitle">{title}</h3>
//                     <div className="menuDescription">{description}</div>
//                     <span className="menuPrice">{currency}{price}</span>

//                     {showNote === true && (
//                         <Note id={menuId} tab={tab} title={title} note={note}/>
//                     )}
//                 </div>

//                 {/* 2. RIGHT COLUMN: Image + Add/Remove Button Container */}
//                 <div className="menuImageContainer">
//                     <div className="image-wrapper-relative" onClick={openDetailPage}>
//                         <img src={src} alt={title} className="itemImage" />
//                     </div>

//                     {/* Floating Add/Remove action button exactly at the bottom center of the image */}
//                     {isAvailable === 1 && guestUser !== true && (
//                         <div className="menuSelectItemFloating">
//                             <SelectItems id={menuId} unit={cart[menuId]} tab={tab} />
//                         </div>
//                     )}
//                 </div>

//             </div>
//         </li>
//     );
// };

// export default MenuCard;

import React, { useEffect, useState } from "react";
import "./newMenuCard.scss";
import SelectItems from "./SelectItem";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { diet, foodTasteLabels } from "../../Utills/enums";
import Note from "./note";
import { IMAGE_BASE_URL } from "../../Utills/config";
import SizeCustomizationModal from "./SizeCustomization";
import ActiveRestaurantModal from "../ActiveRestaurantModal/ActiveRestaurantModal";
import { toast } from "react-toastify";
import {
  fetchMenuData,
  setSelectedCategory,
  clearCart,
  logoutSuccess,
  guestLogin,
} from "../../redux/action";

import { canOrderItem, availabilityText, scheduleMessages } from "../../Utills/menuAvailability";

const MenuCard = ({
  src,
  menuId,
  title,
  typeIcons = [],
  dietIcon,
  description,
  price,
  tab,
  unit,
  currency = "₹",
  isAvailable: manualAvailability,
  showNote,
  note,
}) => {
  const isAvailable = canOrderItem({ ...unit, isAvailable: manualAvailability }) ? 1 : 0;
  const availabilityMessages = scheduleMessages({ ...unit, isAvailable: manualAvailability });
  const { restaurant, id, table } = useParams();
  const cart = useSelector((state) => state?.user.cart);
  const guestUser = useSelector((state) => state?.user.guestUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const packageType = sessionStorage.getItem("packageType");
  const isGuest = packageType === "catelog" || table === "cat";
  const [showCrossRestaurantModal, setShowCrossRestaurantModal] =
    useState(false);
  const [activeSessionDetails, setActiveSessionDetails] = useState(null);
  // const isGuest = guestUser === true || localStorage.getItem("guestUser") === "true";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageLoadFailed, setImageLoadFailed] = useState(false);

  useEffect(() => {
    setImageLoadFailed(false);
  }, [src]);

  // 1. Detect Context: Are we rendering inside the Cart View?
  // In the cart, unit represents a single cart line item which contains our custom payload 'cartKey'
  const isCartView = Boolean(unit?.cartKey);

  // 2. Dynamic Price & Variant Resolution
  const hasVariants =
    !isCartView && unit?.menuSizeOptions && unit.menuSizeOptions.length > 0;

  // Explicit pricing logic: If it's in the cart, show the finalized choice price. Otherwise, show lowest base.
  const displayPrice = isCartView
    ? unit.price
    : hasVariants
      ? Math.min(...unit.menuSizeOptions.map((opt) => opt.price))
      : price;
  const hasDescription = Boolean(description?.trim());
  const hasImage = Boolean(src?.trim()) && !imageLoadFailed;

  const openDetailPage = () => {
    // Only allow deep-linking if we're browsing the active menu catalog
    if (hasDescription && !isCartView) {
      navigate(`/${restaurant}/${id}/${table}/menu/item/${menuId}`);
    }
  };

  useEffect(() => {
    if (table === "takeaway") return;
    const rawUserInfo = localStorage.getItem("userInfo");
    const rawAllInfo = localStorage.getItem("allInfo");

    if (!rawUserInfo) return;

    try {
      const parsedUserInfo = JSON.parse(rawUserInfo);
      let parsedAllInfo = null;
      try {
        parsedAllInfo = rawAllInfo ? JSON.parse(rawAllInfo) : null;
      } catch (err) {
        console.error("Error parsing allInfo:", err);
      }

      const storedRestId = parsedUserInfo?.restaurantId;
      const currentUrlRestId = id;
      const storedTable = parsedUserInfo?.tableNumber;

      // Has the customer ordered food & is the session active?
      const hasActiveUnpaidOrder = Boolean(
        parsedAllInfo &&
        parsedAllInfo.tableOtp &&
        parsedAllInfo.isActive !== false,
      );

      // ── CHECK 1: Scanned a DIFFERENT Restaurant ──
      if (
        currentUrlRestId &&
        storedRestId &&
        storedRestId.toLowerCase() !== currentUrlRestId.toLowerCase()
      ) {
        if (hasActiveUnpaidOrder) {
          setActiveSessionDetails({
            restaurantName:
              localStorage.getItem("restaurant") || "Current Restaurant",
            restaurantId: storedRestId,
            tableNumber: storedTable || parsedAllInfo?.tableNumber,
          });
          setShowCrossRestaurantModal(true);
          return;
        } else {
          console.log(
            `Switching tenant from ${storedRestId} to ${currentUrlRestId}`,
          );
          parsedUserInfo.restaurantId = currentUrlRestId;
          parsedUserInfo.tableNumber = Number(table) || table;
          localStorage.setItem("userInfo", JSON.stringify(parsedUserInfo));
          localStorage.setItem("restaurant", restaurant);
          localStorage.setItem("restaurantId", currentUrlRestId);
          localStorage.setItem("table", table);
          localStorage.removeItem("allInfo");
          // dispatch(clearCart());
        }

        if (storedTable === "cat") {
          //localStorage.removeItem("guestUser");
          // dispatch(guestLogin(false));
          handleForceLogout();
        }
      }

      // ── CHECK 2: Same Restaurant, but switched TABLE ──
      if (table && String(storedTable) !== String(table)) {
        if (!hasActiveUnpaidOrder) {
          console.log(`Switching table from ${storedTable} to ${table}`);
          parsedUserInfo.tableNumber = Number(table) || table;
          localStorage.setItem("userInfo", JSON.stringify(parsedUserInfo));
          localStorage.setItem("table", table);
          dispatch(clearCart());
        } else {
          toast.warn(
            `Unable to switch table to ${table} because your session is active.`,
            {
              toastId: `active-table-warn-${table}`,
            },
          );
        }
      }
    } catch (e) {
      console.error("Error verifying restaurant/table boundaries:", e);
    }
  }, [id, table, restaurant, dispatch]);

  const handleVariantSelected = (chosenVariant) => {
    if (!canOrderItem({ ...unit, isAvailable: manualAvailability })) {
      setIsModalOpen(false);
      toast.warn("This item is currently unavailable.");
      return;
    }
    dispatch({
      type: "ADD_ITEM_MENU",
      payload: {
        id: menuId,
        selectedTab: tab,
        variant: {
          sizeOptionId: chosenVariant.sizeOptionId,
          sizeName: chosenVariant.sizeName,
          price: chosenVariant.price,
        },
      },
    });
  };

  const handleReturnToActiveRestaurant = () => {
    if (!activeSessionDetails) return;
    const oldRest = localStorage.getItem("restaurant") || "active";
    const oldRestId = activeSessionDetails.restaurantId;
    const oldTable = activeSessionDetails.tableNumber;
    navigate(`/${oldRest}/${oldRestId}/${oldTable}/pay-bill`);
  };

  const handleForceLogout = () => {
    const allowedKeys = [
      "customer_portal_theme",
      "showBannerInLoginPage",
      "customer_portal_branch_id",
      "packageType",
      "guestUser",
      "table",
    ];

    Object.keys(sessionStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) sessionStorage.removeItem(key);
    });

    Object.keys(localStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) localStorage.removeItem(key);
    });

    dispatch(logoutSuccess());
    setShowCrossRestaurantModal(false);
    navigate(`/${restaurant}/${id}/${table}`);
  };

  return (
    <>
      <li className={isAvailable ? "menu-li-wrapper" : "menu-li-wrapper over"}>
        <div className={`menuCard${!isAvailable ? " menuCard--unavailable" : ""}`}>
          {/* LEFT COLUMN: Content & Details */}
          <div
            onClick={hasDescription ? openDetailPage : undefined}
            className="menuText"
            style={{ cursor: hasDescription && !isCartView ? "pointer" : "default" }}
          >
            <div className="menu-tags-row">
              {dietIcon && (
                <div className="dietIcon">
                  <img
                    src={dietIcon}
                    alt="diet preference"
                    className="dietIconImg"
                  />
                </div>
              )}

              {unit?.foodTasteMapping?.map((taste) => (
                <label
                  key={taste.foodTasteMappingId}
                  className={
                    taste.foodTasteId === 8
                      ? "jain-badge-card"
                      : "spicy-badge-card"
                  }
                >
                  {foodTasteLabels[taste.foodTasteId]}
                </label>
              ))}
            </div>

            <h3 className="menuTitle">
              {title}
              {/* 3. Display the chosen variant subtitle tag elegantly in the cart view */}
              {isCartView && unit?.variant && (
                <span className="cart-variant-title-tag">
                  {" "}
                  ({unit.variant.sizeName})
                </span>
              )}
            </h3>

            <div className="menuDescription">{description}</div>

            {/* Shows chosen configured price vs "₹316 onwards" baseline parameters */}
            <span className="menuPrice">
              {currency}
              {displayPrice}
            </span>

            {/* {hasVariants && <div className="customizable-badge-text">Customization options available</div>} */}

            {showNote === true && (
              <Note
                id={menuId}
                cartKey={unit?.cartKey || menuId}
                tab={tab}
                title={title}
                note={note}
              />
            )}
          </div>

          {/* RIGHT COLUMN: Image & Adjustments */}
          <div className={`menuImageContainer${!isAvailable && !hasImage && !isCartView ? " menuImageContainer--empty" : ""}${!hasImage ? " menuImageContainer--no-image" : ""}`}>
            <div
              className="image-wrapper-relative"
              onClick={hasDescription ? openDetailPage : undefined}
              style={{ cursor: hasDescription && !isCartView ? "pointer" : "default" }}
            >
              {hasImage ? (
                src.includes("https") ? (
                  <img src={src} alt={title} className="itemImage" onError={() => setImageLoadFailed(true)} />
                ) : (
                  <img
                    src={IMAGE_BASE_URL + src}
                    alt={title}
                    className="itemImage"
                    onError={() => setImageLoadFailed(true)}
                  />
                )
              ) : null}
            </div>

            {/* {isCartView ? (
  // A: Inside Cart -> Use your existing SelectItems control keyed via unique 'cartKey'
  <div className="menuSelectItemFloating">
    <SelectItems id={unit.cartKey} unit={unit} tab={tab} />
  </div>
) : hasVariants ? (
  // B: Item has variants -> Show Customize button
  <div className="menuSelectItemFloating">
  <div className="singleAddBtn" onClick={() => setIsModalOpen(true)}>
    Customize
  </div>
   </div>
) : guestUser !== true ? (
  // C: Standard Item -> Regular increment workflow
  <div className="menuSelectItemFloating">
    <SelectItems id={menuId} unit={cart[menuId]} tab={tab} />
  </div>
) : null} */}

            {isAvailable === 0 || isAvailable === null ? (
              // D: Item not available -> Out of stock
              <div>
                {isCartView && <SelectItems id={unit.cartKey} unit={unit} tab={tab} disabled />}
              </div>
            ) : isCartView && isAvailable ? (
              // A: Inside Cart -> Use your existing SelectItems control keyed via unique 'cartKey'
              <div className="menuSelectItemFloating">
                <SelectItems id={unit.cartKey} unit={unit} tab={tab} />
              </div>
            ) : hasVariants && isAvailable ? (
              // B: Item has variants -> Show Customize button
              <div className="menuSelectItemFloating">
                <button
                  type="button"
                  className="singleAddBtn"
                  onClick={() => setIsModalOpen(true)}
                >
                  Customize
                </button>
              </div>
            ) : isGuest !== true && isAvailable ? (
              // C: Standard Item -> Regular increment workflow
              <div className="menuSelectItemFloating">
                <SelectItems id={menuId} unit={cart[menuId]} tab={tab} />
              </div>
            ) : null}
          </div>
          {!isAvailable && <div className="menu-availability" aria-label="Item availability">
            {availabilityMessages.length ? availabilityMessages.map(message => (
              <p key={message.text} title={`Restaurant time: ${message.timeZone}`}>{message.text}</p>
            )) : <p>{availabilityText({ ...unit, isAvailable: manualAvailability })}</p>}
          </div>}
        </div>

        {/* Selection Modal Component Anchor */}
        {!isCartView && (
          <SizeCustomizationModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            item={unit}
            isGuestUser={isGuest}
            onConfirm={handleVariantSelected}
          />
        )}
      </li>

      <ActiveRestaurantModal
        isOpen={showCrossRestaurantModal}
        activeSession={activeSessionDetails}
        onGoToActive={handleReturnToActiveRestaurant}
        onLogout={handleForceLogout}
      />
    </>
  );
};

export default MenuCard;
